

let count = 0
let map2
let hotelNameG
let hotelData = null // 酒店房间信息

var testList = []

initMyOverlay = function () {
    // 自定义标注
    const MyOverlay = function (center, number) {
        // center = {lng: 116.404, lat: 39.915}
        this._center = center
        this._number = number
        this._length = 20
    }

    // 继承API的BMap.Overlay
    MyOverlay.prototype = new AMap.Overlay()

    // 实现初始化方法
    MyOverlay.prototype.initialize = function (map) {
        // 保存map对象实例
        this._map = map

        // 创建div元素，作为自定义覆盖物的容器
        var div = document.createElement("div")
        div.classList = 'my-overlay-wrap'

        var icon = document.createElement("i")
        icon.classList = 'iconfont icon-location'
        div.appendChild(icon)

        var span = document.createElement("span")
        span.classList = 'my-overlay-index'
        span.textContent = this._number
        div.appendChild(span)

        // 将div添加到覆盖物容器中
        map.getPanes().markerPane.appendChild(div)

        // 保存div实例
        this._div = div

        // 需要将div元素作为方法的返回值，当调用该覆盖物的show、
        // hide方法，或者对覆盖物进行移除时，API都将操作此元素。
        return div
    }

    // 实现绘制方法
    MyOverlay.prototype.draw = function () {
        // 根据地理坐标转换为像素坐标，并设置给容器
        var position = this._map.pointToOverlayPixel(this._center)
        this._div.style.left = position.x - 15 + "px"
        this._div.style.top = position.y - 35 + "px"
    }

    // 实现显示方法
    MyOverlay.prototype.show = function () {
        if (this._div) {
            this._div.style.display = "";
        }
    }
    // 实现隐藏方法
    MyOverlay.prototype.hide = function () {
        if (this._div) {
            this._div.style.display = "none";
        }
    }
}



const
    Util = require('../../../common/util.js'),
    queryString = Util.queryString,
    addDays = Util.addDays,
    priceTableTmpl = require('../templates/priceTableTmpl.ejs'),
    hotelInfoTmpl = require('../templates/hotelInfoTmpl.ejs'),
    hotelInfoDetailsTmpl = require('../templates/hotelInfoDetailsTmpl.ejs'),
    poiTypeTmpl = require('../templates/poiTypeTmpl.ejs'),
    hotelLicensesTmpl = require('../templates/hotelLicensesTmpl.ejs'),
    queryPrices = require('../../../common/hotelPriceUtil/modules/hotelPriceUtil.js'),

    mapKeyArr = ['景点', '餐馆', '便利店', '商场', '游乐园', '公园', '地铁站', '租车店', '火车站', '机场'],



    // 初始化地图的打开
    initOpenMap = function () {
        $(".hdi-open-map").on('click', function () {
            var
                _this = $(this),
                _link = _this.attr('data-link'),
                hotelName = _this.attr('data-hotelname'),
                iWidth = 650,
                iHeight = 500,
                iTop = (window.screen.availHeight - 30 - iHeight) / 2,
                iLeft = (window.screen.availWidth - 10 - iWidth) / 2;

            window.open(_link, hotelName, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no');
        })
    },



    // 将上个页面传过来的参数设置到相应的项
    setInitParams = function (params) {

        var datesInput = document.querySelector(".s-i-dates-input")
        var roomNum = document.querySelector(".s-i-room-num")
        var adultChildren = document.querySelector(".s-i-adult-children")

        var lastQueryParams = sessionStorage.getItem('queryParamsToHotelDetail');		// 上一个页面带过来的查询条件
        if (lastQueryParams) {
            lastQueryParams = window.JSON.parse(lastQueryParams)
            params.selRoomNum = lastQueryParams.selRoomNum
            params.adultNum = lastQueryParams.adultNum
            params.childrenNum = lastQueryParams.childrenNum
            params.childrenAgesStr = lastQueryParams.childrenAgesStr

            if (lastQueryParams.priceRange) {		// 设置价格区间
                var priceArr = lastQueryParams.priceRange.split('-')
                $('#slp_1').val(priceArr[0])
                $('#slp_2').val(priceArr[1])
            }

            if (lastQueryParams.cancelType && ~lastQueryParams.cancelType.indexOf('canceltype-0')) {
                $('.d-s-item[data-value="canceltype-0"]').click()
            }

            if (lastQueryParams.confirmType && ~lastQueryParams.confirmType.indexOf('XS-1')) {
                $('.d-s-item[data-value="XS-1"]').click()
            }

            if (lastQueryParams.confirmType && ~lastQueryParams.confirmType.indexOf('XS-2')) {
                $('.d-s-item[data-value="XS-2"]').click()
            }
        }

        datesInput.checkin = params.startDate;
        datesInput.checkout = params.endDate;
        $(datesInput).val(params.startDate.replace(/-/g, '/') + ' - ' + params.endDate.replace(/-/g, '/'));

        $(roomNum).html(params.selRoomNum + '间').attr('data-value', params.selRoomNum);

        adultChildren.adultNum = params.adultNum;
        adultChildren.childrenNum = params.childrenNum;
        adultChildren.childrenAgesStr = params.childrenAgesStr;
        $(adultChildren).val(params.adultNum + '成人，' + params.childrenNum + '小孩');

        // 如果是境内酒店，则隐藏成人小孩的选择框
        // if (params.type === '0') {
        //     $(".s-i-adult-children-wrap").remove();
        // }
    },

    // 设置酒店信息
    setHotelInfo = function (data) {
        // 设置酒店图片
        data.picList = data.picList || [];
        var picArr = data.picSrc.split('|');
        if (!data.picList.length) data.picList = picArr;
        data.picSrc = picArr[0];

        // 设置酒店名称
        $("#hotel-name").html(data.infoName);

        // 填充酒店信息
        $(".hotel-detail-info-outer").html(hotelInfoTmpl({ o: data }));
        $(".hotel-detail-outer").html(hotelInfoDetailsTmpl({ o: data }));
        $("#acWrap").html(hotelLicensesTmpl({ o: data }));

        // initOpenMap();

        hotelData = data

        // // 引入坐标系转换插件
        // var url ="https://unpkg.com/gcoord/dist/gcoord.global.prod.js";
        // var jsapi = document.createElement("script");
        // jsapi.src = url;
        // document.body.appendChild(jsapi);

        // 如果是国外酒店则加载微软地图
        if(data.countryType == 3) {
            loadBinMap()
        } else {
            // loadBinMap()
            loadJScript()
        }
    },

    // 2021-5-4地图改为异步加载，且不要影响查价列表   二. 2024-03-28将国内的百度地图改为高德地图
    loadJScript = function () {
        //设置你的安全密钥
        window._AMapSecurityConfig = {
            securityJsCode: "29c997b3acbee02306d298f32a52affe",
        };
        //声明异步加载回调函数
        window.onLoad = function () {
            var map = new AMap.Map("mapCon1"); //"mapCon1"为<div>容器的id
        };
        var url ="https://webapi.amap.com/maps?v=2.0&key=10ea136f173c976c698b72830aa582b2&callback=initMap";
        var jsapi = document.createElement("script");
        // jsapi.charset = "utf-8";
        jsapi.src = url;
        document.body.appendChild(jsapi);

        // var script = document.createElement('script');
        // console.log('我执行了吗????',script);
        // script.type = 'text/javascript';
        // script.src = '//api.map.baidu.com/api?v=2.0&ak=5QdDsDipKH6OCOKjSP3SgdT7VGGYlbWL&s=1&callback=initMap';
        // document.body.appendChild(script);
    }

    // 2024-03-28将国外的百度地图改为微软地图
    loadBinMap = function () {
        
        //声明异步加载回调函数
        // window.onLoad = function () {
        //     var map = new AMap.Map("mapCon1"); //"mapCon1"为<div>容器的id
        // };
        var url ="https://www.bing.com/api/maps/mapcontrol?callback=GetBinMap&key=AkWVMxrbKvEVAZW8S9fwiOL9Q70uKer-kgpKwExVOVz3WbtDq0IsDEYJhRKo6_av&setLang=zh-CN";   //GetBinMap 为异步回调函数
        var jsapi = document.createElement("script");
        // jsapi.charset = "utf-8";
        jsapi.src = url;
        document.body.appendChild(jsapi);
    }

    // 微软地图的回调
    GetBinMap = function() {
        // initMyOverlay()
        setBinMap(hotelData)
        // initPOItitleEvents(hotelData)
    }

    //设置微软地图
    setBinMap = function (data) {
        var result = gcoord.transform(
            [+data.longitude, +data.latitude],    // 经纬度坐标
            gcoord.BD09,               // 当前坐标系
            gcoord.GCJ02               // 目标坐标系
        );

        $('.poi-hotel-name-outer .name').html(data.infoName)
        $('.poi-hotel-name-outer .address').html(data.address)
        var map = new Microsoft.Maps.Map('#mapCon1',{
            zoom: 12,
            center: new Microsoft.Maps.Location(result[1],result[0]),//中心点
        });
        

        //获取当前地图的中心点
        var center = map.getCenter();
        // 创建点标记点
        var pin = new Microsoft.Maps.Pushpin(center, {
            icon: "https://api.map.baidu.com/images/marker_red_sprite.png",
        });
        //添加标记点到地图上
        map.entities.push(pin);

        // 创建信息窗口
        var infobox = new Microsoft.Maps.Infobox(center, {
            htmlContent: `
                <div class="customInfobox">
                    ${hotelData.infoName}
                </div>
            `
        });
        // 添加信息窗口在地图上
        infobox.setMap(map);

        //设置下方地图和附近酒店
        setBinMaker(data);  

        // 创建一个 div 按钮，插入到地图的右下角，滑到底部地图
        var div = document.createElement('a')
        div.href = '#hotelMap'
        div.classList = 'check-map-detail'
        div.appendChild(document.createTextNode("查看地图"))
        // map.getContainer().appendChild(div)
        $("#mapCon1").append(div);
    }


    // 高德地图的回调
    initMap = function () {
        // initMyOverlay()
        setMap(hotelData)
        // initPOItitleEvents(hotelData)
    }


    // 设置地图
    setMap = function (data) {
        $('.poi-hotel-name-outer .name').html(data.infoName)
        $('.poi-hotel-name-outer .address').html(data.address)
        hotelNameG = data.infoName

        var point = new AMap.LngLat(+data.longitude, +data.latitude);
        // var point = new BMap.Point(116.404, 39.915)
        pointAfterConvert(point);
        return

        if (data.countryType == 3) {	// 如果是境外，则先要转换坐标
            // var convertor = new AMap.convertFrom();
            // var pointArr = [];
            // pointArr.push(point);
            // convertor.translate(pointArr, 3, 5, translateCallback)

            //参数说明：需要转换的坐标，需要转换的坐标类型，转换成功后的回调函数
            AMap.convertFrom([point], "gps", function (status, result) {
                //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
                //查询成功时，result.locations 即为转换后的高德坐标系
                if (status === "complete" && result.info === "ok") {
                    var lnglats = result.locations; //转换后的高德坐标 Array.<LngLat>
                    console.log(lnglats);
                }
            });

        } else {
            pointAfterConvert(point)
        }
    },

    translateCallback = function (data) {
        if (data.status === 0) {
            pointAfterConvert(data.points[0])
        }
    },

    pointAfterConvert = function (point) {

        var result = gcoord.transform(
            [+point.lng, +point.lat],    // 经纬度坐标
            gcoord.BD09,               // 当前坐标系
            gcoord.GCJ02               // 目标坐标系
        );
        // 右上方酒店信息框内的小地图
        var map = new AMap.Map("mapCon1")
        $(".amap-logo").remove()
        $(".amap-copyright").remove()
        
        map.setZoomAndCenter(15, new AMap.LngLat(result[0], result[1])); //同时设置地图层级与中心点
        map.setFeatures(['bg', 'road', 'building', 'point']);

        var marker = new AMap.Marker({
            position: new AMap.LngLat(result[0], result[1]),
            offset: new AMap.Pixel(0, 0),
            icon: "https://api.map.baidu.com/images/marker_red_sprite.png", 
        });
        map.add(marker);

        // 创建一个自定义窗口
        var customTitle = document.createElement('div');
        customTitle.style.padding = '5px';
        customTitle.style.background = 'white';
        customTitle.style.border = '1px solid #ccc';
        customTitle.style.width = '145px';
        customTitle.style.position = 'absolute';
        customTitle.style.top = '-130%';
        customTitle.style.left = '-180%';
        customTitle.style.textAlign = 'center';
        customTitle.style.backgroundColor = '#ff4500';
        customTitle.style.color = '#fff';
        customTitle.style.fontSize = '12px';
        customTitle.style.whiteSpace = 'nowrap';
        customTitle.style.overflow = 'hidden';
        customTitle.style.textOverflow = 'ellipsis';
        customTitle.innerHTML = hotelData.infoName;
        $("#mapCon1").find(".amap-marker").append(customTitle);

        // 创建一个 div 按钮，插入到地图的右下角，滑到底部地图
        var div = document.createElement('a')
        div.href = '#hotelMap'
        div.classList = 'check-map-detail'
        div.appendChild(document.createTextNode("查看地图"))
        map.getContainer().appendChild(div)

        // 下方的大图
        window.setTimeout(() => {
            var marker1 = new AMap.Marker({
                position: new AMap.LngLat(result[0], result[1]),
                offset: new AMap.Pixel(0, 0),
                zIndex: 999,
                icon: "https://api.map.baidu.com/images/marker_red_sprite.png", 
                extData: {
                    className: 'my-marker-class' // 设置类名
                }
            });
            var map2 = new AMap.Map("MapContainer")
            $(".amap-logo").remove()
            $(".amap-copyright").remove()
            map2.setZoomAndCenter(15, new AMap.LngLat(result[0], result[1])); //同时设置地图层级与中心点
            map2.setFeatures(['bg', 'road', 'building', 'point']);
            map2.add(marker1);
            setLessMapMaker(map2)  //设置附近地图标志
        },1000)


        

        return

        map.centerAndZoom(point, 15)
        map.enableScrollWheelZoom(true)

        var marker = new BMap.Marker(point);  	// 创建标注
        map.addOverlay(marker);              	// 将标注添加到地图中
        marker.setAnimation(BMAP_ANIMATION_BOUNCE)

        // 下方的大图
        map2 = new BMap.Map("MapContainer")
        map2.centerAndZoom(point, 15)
        map2.enableScrollWheelZoom(true)
        map2.addControl(new BMap.NavigationControl())
        map2.addControl(new BMap.MapTypeControl({ mapTypes: [BMAP_NORMAL_MAP, BMAP_SATELLITE_MAP] }))

        setMapMaker(point)
        setLessMapMaker()  //设置附近地图标志

        // 创建一个 div 按钮，插入到地图的右下角，滑到底部地图
        var div = document.createElement('a')
        div.href = '#hotelMap'
        div.classList = 'check-map-detail'
        div.appendChild(document.createTextNode("查看地图"))
        map.getContainer().appendChild(div)

        var local = new BMap.LocalSearch(map2)
        local.setSearchCompleteCallback(searchCompleteCallBack)
        for (let i = 0; i < mapKeyArr.length; i++) {
            local.searchNearby(mapKeyArr[i], point, 1000)
        }
    },

    // 设置微软地图的附近和打点
    setBinMaker = function (data) {
        var result = gcoord.transform(
            [+data.longitude, +data.latitude],    // 经纬度坐标
            gcoord.BD09,               // 当前坐标系
            gcoord.GCJ02               // 目标坐标系
        );
        // 下方的大图
        var map = new Microsoft.Maps.Map('#MapContainer',{
            zoom: 12,
            center: new Microsoft.Maps.Location(result[1],result[0]),//中心点
        });
        window.setTimeout(() => {
            $(".NavBar_Container").remove()
            $(".bm_bottomLeftOverlay").remove()
        },300)

        //获取当前地图的中心点
        var center = map.getCenter();
        // 创建点标记点
        var pin = new Microsoft.Maps.Pushpin(center, {
            icon: "https://api.map.baidu.com/images/marker_red_sprite.png",
        });

        //添加标记点到地图上
        map.entities.push(pin);

        // 创建信息窗口
        var infobox = new Microsoft.Maps.Infobox(center, {
            htmlContent: `
                <div class="customInfobox curShow">
                    ${data.infoName}
                </div>
            `
        });
        // 添加信息窗口在地图上
        infobox.setMap(map);

        // 添加事件监听器-鼠标移入
        Microsoft.Maps.Events.addHandler(pin, 'mouseover', function (e) {
            // 鼠标悬停时的操作
            $(".curShow").css({
                display:"block"
            })
        });
        // 添加事件监听器-鼠标移出
        Microsoft.Maps.Events.addHandler(pin, 'mouseout', function (e) {
            // 鼠标悬停时的操作
            $(".curShow").css({
                display:"none"
            })
        });

        $(".poi-hotel-name-outer").on('mouseover', function () {   //鼠标移入文字
            $(`#MapContainer`).find(".curShow").css({
                display: 'block'
            })
        })

        $(".poi-hotel-name-outer").on('mouseout', function () {   //鼠标移出文字
            $(`#MapContainer`).find(".curShow").css({
                display: 'none'
            })
        })

        $(".poi-hotel-name-outer").on('click', function () {   //鼠标点击地图变化
            // 将地图中心设置为标记位置
            map.setView({ center: center });
        })

        // 附近酒店
        $('.nearby-hotel-info').empty()
        if (testList.length === 0) {
            return
        }

        testList.forEach((item, index) => {
            // 添加附近酒店数据到html
            var newHistory = `
                <div class="info-item">
                    <div>${item.infoName}</div>
                    <div class="item-div">
                        <div>${item.address}</div>
                    </div>
                </div>
            `
            $(newHistory).appendTo('.nearby-hotel-info');

            var result1 = gcoord.transform(
                [+item.longitude, +item.latitude],    // 经纬度坐标
                gcoord.BD09,               // 当前坐标系
                gcoord.GCJ02               // 目标坐标系
            );
            // 创建信息窗口
            var infobox = new Microsoft.Maps.Infobox(new Microsoft.Maps.Location(result1[1],result1[0]), {
                htmlContent: `
                    <div class="lable-price-css lable-all${index}">
                        <div class="label-tixing${index} childLable" style="background-color: #fff;text-align: center;position:absolute;top:-65px;left:-85px;padding:5px;border:1px solid #333;border-radius:5px;display:none;">
                                <h1 style="color:#333;font-size:14px;width:210px;margin-bottom:5px;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">${item.infoName}</h1>
                                <span style="color:#0066ff;font-size:13px;">${item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : '未查询到报价'}</span>
                                <span style="color:#333;margin-top:5px;font-size:13px;">起</span>
                        </div>
                        <span class="nearyBy-label${index} nearyByItem ">
                            ${item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : "未查询到报价" }  
                        </span>
                    </div>
                `
            });
            // 添加信息窗口在地图上
            infobox.setMap(map);

            // 拿到右边附近酒店元素
            var hotelNameOuter = $(`.info-item`)[index];

            $(hotelNameOuter).on('mouseover', function () {   //鼠标移入文字
                $(`.label-tixing${index}`).css({
                    display: 'block'
                })
            })
            $(hotelNameOuter).on('mouseout', function () {   //鼠标移出文字
                $(`.label-tixing${index}`).css({
                    display: 'none'
                })
            })
            $(hotelNameOuter).on('click', function () {   //鼠标点击地图变化
                // 将地图中心设置为标记位置
                map.setView({ center: new Microsoft.Maps.Location(result1[1],result1[0]) });
            })

        })
    },


    //设置附近地图标志
    setLessMapMaker = function (map2) {
        // 创建一个自定义窗口
        var customTitle = document.createElement('div');
        customTitle.classList.add('new-class');
        customTitle.style.padding = '5px';
        customTitle.style.background = 'white';
        customTitle.style.border = '1px solid #ccc';
        customTitle.style.width = '170px';
        customTitle.style.position = 'absolute';
        customTitle.style.top = '-130%';
        customTitle.style.left = '-210%';
        customTitle.style.textAlign = 'center';
        customTitle.style.backgroundColor = '#ff4500';
        customTitle.style.color = '#fff';
        customTitle.style.fontSize = '13px';
        customTitle.style.whiteSpace = 'nowrap';
        customTitle.style.overflow = 'hidden';
        customTitle.style.textOverflow = 'ellipsis';
        customTitle.style.display = 'none';
        customTitle.innerHTML = hotelData.infoName;
        $("#MapContainer").find(".amap-marker").append(customTitle);

        var result1 = gcoord.transform(
            [+hotelData.longitude, +hotelData.latitude],    // 经纬度坐标
            gcoord.BD09,               // 当前坐标系
            gcoord.GCJ02               // 目标坐标系
        );

        $(".poi-hotel-name-outer").on('mouseover', function () {   //鼠标移入文字
            $(`#MapContainer`).find(".amap-marker .new-class").parent(".amap-marker").css({
                'z-index': '999'
            })
            $(`#MapContainer`).find(".amap-marker .new-class").css({
                display: 'block'
            })
        })

        $(".poi-hotel-name-outer").on('mouseout', function () {   //鼠标移出文字
            $(`#MapContainer`).find(".amap-marker .new-class").parent(".amap-marker").css({
                'z-index': '998'
            })
            $(`#MapContainer`).find(".amap-marker .new-class").css({
                display: 'none'
            })
        })

        $(".poi-hotel-name-outer").on('click', function () {   //鼠标点击地图变化
            map2.setCenter([result1[0], result1[1]]) //map为地图实例,lng为经度,lat为纬度
        })

        $("#MapContainer .amap-marker .new-class").parent(".amap-marker").on('mouseover', function () {   //鼠标移入icon
            $(this).css({
                'z-index': '999'
            })
            $(this).find(".new-class").css({
                display: 'block'
            })
        })

        $("#MapContainer .amap-marker .new-class").parent(".amap-marker").on('mouseout', function () {   //鼠标移出icon
            $(this).css({
                'z-index': '12'
            })
            $(this).find(".new-class").css({
                display: 'none'
            })
        })


        $('.nearby-hotel-info').empty()
        if (testList.length === 0) {
            return
        }
        // 获取已创建的地图容器

        testList.forEach((item, index) => {
            // 添加附近酒店数据到html
            var newHistory = `
				<div class="info-item">
					<div>${item.infoName}</div>
					<div class="item-div">
						<div>${item.address}</div>
					</div>
				</div>
			`
            $(newHistory).appendTo('.nearby-hotel-info')

            let content = `
                <div class="lable-price-css lable-all${index}">
                    <div class="label-tixing${index} childLable" style="background-color: #fff;text-align: center;position:absolute;top:-65px;left:-85px;padding:5px;border:1px solid #333;border-radius:5px;display:none;">
                            <h1 style="color:#333;font-size:14px;width:210px;margin-bottom:5px;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">${item.infoName}</h1>
                            <span style="color:#0066ff;font-size:13px;">${item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : '未查询到报价'}</span>
                            <span style="color:#333;margin-top:5px;font-size:13px;">起</span>
                    </div>
                    <span class="nearyBy-label${index} nearyByItem ">
                        ${item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : "未查询到报价" }  
                    </span>
                </div>
            `

            var result2 = gcoord.transform(
                [+item.longitude, +item.latitude],    // 经纬度坐标
                gcoord.BD09,               // 当前坐标系
                gcoord.GCJ02               // 目标坐标系
            );
            // 创建文本标记
            var marker = new AMap.Marker({
                position: new AMap.LngLat(result2[0], result2[1]),
                offset: new AMap.Pixel(0, 0),
                // icon: "https://api.map.baidu.com/images/marker_red_sprite.png", 
                content:content
            });
            map2.add(marker);

            // 拿到右边附近酒店元素
            var hotelNameOuter = $(`.info-item`)[index];

            $(hotelNameOuter).on('mouseover', function () {   //鼠标移入文字
                $(`.lable-all${index}`).parent(".amap-marker").css({
                    'z-index': '999'
                })
                $(`.label-tixing${index}`).css({
                    display: 'block'
                })
            })
            $(hotelNameOuter).on('mouseout', function () {   //鼠标移出文字
                $(`.lable-all${index}`).parent(".amap-marker").css({
                    'z-index': '12'
                })
                $(`.label-tixing${index}`).css({
                    display: 'none'
                })
            })

            
            $(hotelNameOuter).on('click', function () {   //鼠标点击地图变化
                map2.setCenter([result2[0], result2[1]]) //map为地图实例,lng为经度,lat为纬度
            })



            return
            let point = { lat: item.latitude, lng: item.longitude }
            var icon = new BMap.Icon('https://s3.bmp.ovh/imgs/2022/04/11/4d650aa0123df092.png', new BMap.Size(0, 0))
            var marker = new BMap.Marker(point, { icon: icon });  	// 创建标注
            map2.addOverlay(marker);              	// 将标注添加到地图中

            var opts = {
                position: point,    					// 指定文本标注所在的地理位置
                offset: new BMap.Size(0, -1)    	//设置文本偏移量
            }
            //class: poi-item-lable-content
            var label = new BMap.Label(`
			<div class="label-tixing" style="background-color: #fff;text-align: center;position:absolute;top:-65px;left:-85px;padding:5px;border:1px solid #333;border-radius:5px;display:none;">
					<h1 style="color:#333;font-size:14px;width:210px;margin-bottom:5px;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">${item.infoName}</h1>
					<span style="color:#0066ff;font-size:13px;">${item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : '未查询到报价'}</span>
					<span style="color:#333;margin-top:5px;font-size:13px;">起</span>
            </div>
			<span class="nearyBy-label${index}">` + (item.hasOwnProperty('minPrice') && item.minPrice ? '￥' + item.minPrice : '未查询到报价') + '</span>', opts);  // 创建文本标注对象
            label.setStyle({
                transform: "translate(-50%, 0)",
                border: "none",
                color: "white",
                background: "#0066ff",
                padding: "5px 10px",
                lineHeight: "20px",
                boxShadow: "0 0px 5px #0066ff",
            });

            var hotelNameOuter = $('.info-item')[index]
            // console.log('hotelNameOuter',hotelNameOuter);
            hotelNameOuter.marker = marker
            hotelNameOuter.label = label
            map2.addOverlay(hotelNameOuter.label)
            // hotelNameOuter.label.hide()  //隐藏文本提升
            hotelNameOuter.point = point

            $(hotelNameOuter).on('mouseover', function () {   //鼠标移入文字
                let domData = $(this)[0].label.V.children[0]
                $(domData).parent().css({
                    'z-index': '129398569'
                })
                $(domData).css({
                    display: 'block'
                })
            })
            $(hotelNameOuter).on('mouseout', function () {   //鼠标移出文字
                let domData = $(this)[0].label.V.children[0]
                $(domData).parent().css({
                    'z-index': '12939856'
                })
                $(domData).css({
                    display: 'none'
                })
            })

            $(hotelNameOuter).on('click', function () {   //鼠标点击地图变化
                map2.panTo(new BMap.Point(point.lng, point.lat))
            })

            $(document).on('mouseover', `.nearyBy-label${index}`, function () {
                $(this).parent().css({
                    'z-index': '129398569'
                })
                $(this).prev('.label-tixing').css({
                    display: 'block',
                })
            })

            $(document).on('mouseout', `.nearyBy-label${index}`, function () {
                $(this).parent().css({
                    'z-index': '12939856'
                })
                $(this).prev('.label-tixing').css({
                    display: 'none',
                })

            })

        })

    },

    // 设置地图主标注
    setMapMaker = function (point) {
        var marker = new BMap.Marker(point);  	// 创建标注
        map2.addOverlay(marker);              	// 将标注添加到地图中
        marker.setAnimation(BMAP_ANIMATION_BOUNCE)

        var opts = {
            position: point,    					// 指定文本标注所在的地理位置
            offset: new BMap.Size(0, -80)    	//设置文本偏移量
        }
        var label = new BMap.Label('<span class="poi-item-lable-content">' + hotelNameG + '</span>', opts);  // 创建文本标注对象
        label.setStyle({
            transform: "translate(-50%, 0)",
            border: "none",
            color: "white",
            background: "orangered",
            padding: "5px 10px",
            lineHeight: "20px",
            boxShadow: "0 0px 5px #ec7764",
        });

        var hotelNameOuter = document.querySelector('.poi-hotel-name-outer')
        hotelNameOuter.marker = marker
        hotelNameOuter.label = label
        map2.addOverlay(hotelNameOuter.label)
        hotelNameOuter.label.hide()
        hotelNameOuter.point = point

        setTimeout(function () {
            hotelNameOuter.marker.V.label = hotelNameOuter.label
            $(hotelNameOuter.marker.V).on('mouseover', function () {
                this.label.show()
            })
            $(hotelNameOuter.marker.V).on('mouseout', function () {
                this.label.hide()
            })
        }, 300)

        $('.poi-hotel-name-outer').on('mouseover', function () {
            var marker = this.marker
            $('.my-overlay-wrap').removeClass('active')

            var allArr = $('.poi-item-li')
            for (let i = 0; i < allArr.length; i++) {	// 先将所有自定义标注隐藏
                allArr[i].label.hide()
                allArr[i].MyOverlay.hide()
            }

            this.label.show()
        })

        $('.poi-hotel-name-outer').on('mouseout', function () {
            this.marker.V.label.hide()
        })

        $('.poi-hotel-name-outer').on('click', function () {
            var point = this.point
            map2.panTo(new BMap.Point(point.lng, point.lat))
        })
    },

    searchCompleteCallBack = function (res) {
        let poiWrap = $('#mapNavInner li').filter(function (i, n) {
            return $(n).attr('data-key') === res.keyword
        })

        if (res.bR > 0) {
            for (let i = 0; i < res.Ar.length; i++) {
                const o = res.Ar[i];
                o.url = o.url.replace(/gsp0.baidu.com\/80MWsjip0QIZ8tyhnq/g, 'map.baidu.com')
            }

            res.len = Math.min(5, res.bR)
            poiWrap.find('.poi-type-num').html(res.len + '家')
            poiWrap.find('.poi-type-res-wrap').html(poiTypeTmpl(res))
        } else {
            poiWrap.remove()
        }

        count++
        if (count >= res.len) {
            $($('.poi-type-res-wrap')[0]).removeClass('hidden')
            addAllOverlay()
        }
    },

    // 将所有自定义标注添加到地图
    addAllOverlay = function () {
        var arr = $('.poi-item-li')

        for (let i = 0; i < arr.length; i++) {
            let point = JSON.parse(decodeURIComponent($(arr[i]).attr('data-point')))
            let index = $(arr[i]).attr('data-index')

            arr[i].MyOverlay = new MyOverlay(point, index)
            map2.addOverlay(arr[i].MyOverlay)
            arr[i].MyOverlay.hide()		// 先隐藏标注

            var opts = {
                position: point,    					// 指定文本标注所在的地理位置
                offset: new BMap.Size(0, -70)    	//设置文本偏移量
            }
            var title = $(arr[i]).find('.title').attr('data-title')
            var label = new BMap.Label('<span class="poi-item-lable-content">' + title + '</span>', opts);  // 创建文本标注对象
            label.setStyle({
                transform: "translate(-50%, 0)",
                border: "none",
                color: "white",
                background: "orangered",
                padding: "5px 10px",
                lineHeight: "20px",
                boxShadow: "0 0px 5px #ec7764",
            });
            arr[i].label = label
            map2.addOverlay(arr[i].label)
            arr[i].label.hide()

            arr[i].MyOverlay._div.MyOverlay = arr[i].MyOverlay
            arr[i].MyOverlay._div.label = arr[i].label
        }

        initOverlayHover()
    },

    initOverlayHover = function () {
        $('.my-overlay-wrap').on('mouseover', function () {
            this.label.show()
            $(this).addClass('active')
        })

        $('.my-overlay-wrap').on('mouseout', function () {
            this.label.hide()
            $(this).removeClass('active')
        })
    },

    initPOItitleEvents = function (data) {
        // 查看酒店证照信息
        $(document).delegate('#showLicenses', 'click', function () {
            let showLicensesDOM = null;
            var he = $()
            showLicensesDOM = layer.open({
                type: 1,
                title: false,
                // closeBtn: 0,
                area: ['60%', '68%'],
                shade: 0.5,
                content: hotelLicensesTmpl({
                    o: data
                })
            })
        });

        // poi 头部点击事件
        $(document).delegate('.poi-type-title', 'click', function () {
            var arr = $(this).closest('ul').find('.poi-type-res-wrap')
            arr.slideUp('fast')
            var thisWrap = $(this).parent().find('.poi-type-res-wrap')
            if (thisWrap.css('display') === 'block') {
                thisWrap.slideUp('fast')
            } else {
                thisWrap.slideDown('fast')
            }
        })

        // poi 大块的鼠标悬停事件
        $(document).delegate('.poi-block-li', 'mouseover', function () {
            var allArr = $('.poi-item-li')
            var arr = $(this).find('.poi-item-li')

            for (let i = 0; i < allArr.length; i++) {	// 先将所有自定义标注隐藏
                allArr[i].MyOverlay.hide()
            }

            for (let i = 0; i < arr.length; i++) {		// 再将鼠标所处的大块区域内的自定义标注显示
                arr[i].MyOverlay.show()
            }
        })

        // poi 大块的鼠标移出事件
        $(document).delegate('.poi-block-li', 'mouseout', function () {
            var allArr = $('.poi-item-li')
            for (let i = 0; i < allArr.length; i++) {	// 先将所有自定义标注隐藏
                allArr[i].label.hide()
            }
        })

        // poi 单项的鼠标悬停事件
        $(document).delegate('.poi-item-li', 'mouseover', function () {
            var myOverlay = this.MyOverlay
            $('.my-overlay-wrap').removeClass('active')
            $(myOverlay._div).addClass('active')

            var allArr = $('.poi-item-li')
            for (let i = 0; i < allArr.length; i++) {	// 先将所有自定义标注隐藏
                allArr[i].label.hide()
            }

            this.label.show()
        })

        // poi 单项的鼠标移出事件
        $(document).delegate('.poi-item-li', 'mouseout', function () {
            var myOverlay = this.MyOverlay
            $(myOverlay._div).removeClass('active')
            this.label.hide()
        })

        // poi 单项的鼠标点击事件
        $(document).delegate('.poi-item-li', 'click', function () {
            var center = this.MyOverlay._center
            map2.panTo(new BMap.Point(center.lng, center.lat))
        })
    },

    // 根据参数查询酒店
    queryHotels = function (params) {
        $.post('/hotel/getHotelInfoList.do', params, function (res) {
            if (res.returnCode === 1) {
                if (res.dataList && res.dataList.length) {
                    setHotelInfo(res.dataList[0]);
                    // console.log('$.queryingHotelParams1',$.queryingHotelParams);
                    // $.queryingHotelParams.type = res.dataList[0].countryType || "0";
                    // console.log('countryType',res.dataList[0].countryType);
                    // console.log('$.queryingHotelParams2',$.queryingHotelParams);

                    let neabyHotelList = res.dataList[0].staticInfoList && res.dataList[0].staticInfoList.length ? res.dataList[0].staticInfoList : []
                    let hotelId = res.dataList[0].infoId
                    if (neabyHotelList.length > 0) {
                        for (let i = 0; i < neabyHotelList.length; i++) {
                            if (neabyHotelList[i].staticInfoId == hotelId) {
                                neabyHotelList.splice(i, 1);
                                break;
                            }
                        }
                    }
                    if (neabyHotelList.length > 4) {
                        testList = neabyHotelList.slice(0, 4)
                    } else {
                        testList = neabyHotelList
                    }
                    // 如果附近酒店为空
                    if(!neabyHotelList || !neabyHotelList.length) {
                        $(".nearby-hotel").empty()
                    }
                }
            }
        });
    },

    // 设置 nav 上的城市类型
    setNavText = function (citytype) {
        var navText =
            citytype == 2 ? '港澳台' :
                citytype == 3 ? '海外' : '国内';

        $("#cityTypeText").html(navText);
    },

    // 获取上个页面传过来的参数，然后初始化页面
    getInitParamsAndInitPage = function () {
        var hotelId = queryString('hotelId');
        var hotelIdObj = $("#hotelId");
        var checkin = queryString('checkin');
        var checkout = queryString('checkout');
        var citytype = queryString('ch');
        var selRoomNum = queryString('selRoomNum') || 1;  //房间数
        var adultNum = queryString('adultNum') || 2;  //成人数量
        var childrenNum = queryString('childrenNum') || 0;  //儿童数量
        var childrenAgesStr = queryString('childrenAgesStr') || '';  //儿童年龄段

        if (citytype != 0 && citytype != 2 && citytype != 3) citytype = 0

        // 修复由首页广告带过来的日期是以前日期的 bug
        if (citytype == 3) {	// 境外
            if ((+new Date() + 24 * 60 * 60 * 1000) > +new Date(checkin.replace(/-/g, '/') + ' 23:59:59')) {
                checkin = addDays(new Date(), 1);
                checkout = addDays(new Date(), 2);
            }
        } else {
            if (+new Date() > +new Date(checkin.replace(/-/g, '/') + ' 23:59:59')) {
                checkin = addDays(new Date(), 0);
                checkout = addDays(new Date(), 1);
            }
        }


        var params = {
            'infoIds': hotelId,
            "type": citytype,
            "startDate": checkin,
            "endDate": checkout,
            "selRoomNum": selRoomNum,
            "adultNum": adultNum,
            "childrenNum": childrenNum,
            "childrenAgesStr": childrenAgesStr,
            "pageNow": 1
        };

        hotelIdObj.attr('data-hotelid', hotelId);

        setNavText(citytype);

        setInitParams(params);

        $.queryingHotelParams = params;

        queryPrices(hotelIdObj[0], params, priceTableTmpl);

        queryHotels(params);

    },

    // 初始化屏幕滚动
    initPageScroll = function () {
        window.setTimeout(() => {
            
            window.onscroll = function () {
                var elem = $('.hli-expand-inner .icon-up')[0],
                    clientHeight = document.documentElement.clientHeight;

                if (elem) {
                    const
                        o = $('.hli-expand-inner')[0],
                        p = $(o).closest('.hli-price-list-wrap')[0],
                        rect = p.getBoundingClientRect();

                    if (rect.bottom >= clientHeight) {
                        $(o).addClass('fix-bottom');
                    } else {
                        $(o).removeClass('fix-bottom');
                    }

                    if (rect.top >= clientHeight - 300) {
                        $(o).removeClass('fix-bottom');
                    }

                    if (rect.top <= 90) {
                        $('.search-line-outer').addClass('fix-top');
                    } else {
                        $('.search-line-outer').removeClass('fix-top');
                    }
                } else {
                    $('.search-line-outer').removeClass('fix-top');
                }
            }
        },5000)
    };


// 刚进入列表页面时，做的一些初始化
module.exports = {
    run: function () {

        // 获取上个页面传过来的参数，然后初始化页面
        getInitParamsAndInitPage();

        // 初始化屏幕滚动
        initPageScroll();
    }
}



// WEBPACK FOOTER //
// ./src/js/hotelDetail/modules/initials.js